import { saCards } from "@/data/siteData";
import worldMapImg from "@/assets/world-map-connections.webp";
import saFlag from "@/assets/africa-flag-new.webp";

export function SouthAfricaSection() {
  return (
    <section id="whysouthafrica" className="py-10 md:py-14 bg-muted">
      <div className="container-main">
        <div className="grid lg:grid-cols-2 gap-10 items-center mb-10">
          {/* Content */}
          <div>
            <div className="flex items-start gap-4 mb-6">
              <h2 className="text-3xl md:text-4xl lg:text-[42px] font-bold text-foreground uppercase leading-tight">
                South Africa.<br />
                Aligned with the<br />
                World.
              </h2>
              <img src={saFlag} alt="South African Flag" className="h-16 md:h-24 w-auto mt-1 flex-shrink-0" />
            </div>
            <ul className="text-muted-foreground text-base leading-relaxed space-y-1 list-disc list-inside">
              <li>First-language English speakers with neutral accents</li>
              <li>Time zone compatibility with US, UK, EU & AU</li>
              <li>Cost-effective without compromising quality</li>
              <li>Driven by a strong work ethic and dedication</li>
              <li>Enterprise-grade infrastructure</li>
              <li>Strong Western market alignment</li>
              <li>Trusted outsourcing destination</li>
            </ul>
          </div>

          {/* Map */}
          <div>
            <img
              src={worldMapImg}
              alt="IntelliBPO serves United States, United Kingdom, Australia from South Africa"
              className="w-[120%] h-auto max-w-none"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
